import EmptyResult from 'components/others/EmptyResult';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import type { VendorType } from '@econtractor/types';
import VendorsTableRow from './VendorsTableRow';
import { useVendors } from '../context/VendorsProvider';

interface VendorsTableBodyProps {
    vendorsList: VendorType[];
    fetchVendors: (force?: boolean) => Promise<void>;
    setEditVendorId: (vendorId: number) => void;
    setSubjectsVendorId: (vendorId: number) => void;
    setPersonsVendorId: (vendorId: number) => void;
    onOpenPrimaryContacts: (vendor: VendorType) => void;
}

const VendorsTableBody = ({
    vendorsList,
    fetchVendors,
    setEditVendorId,
    setSubjectsVendorId,
    setPersonsVendorId,
    onOpenPrimaryContacts,
}: VendorsTableBodyProps) => {
    const { auth } = useAuth();
    const { showContact, showWebsite } = useVendors();
    const canEdit = hasUserAccess(auth?.user, 'prodEdit');
    const colSpan = 2
        + (showContact ? 1 : 0)
        + (showWebsite ? 1 : 0)
        + (canEdit ? 1 : 0);

    return (
        <tbody>
            {vendorsList.map((vendor) => (
                <VendorsTableRow
                    key={vendor.ID}
                    vendor={vendor}
                    fetchVendors={fetchVendors}
                    setEditVendorId={setEditVendorId}
                    setSubjectsVendorId={setSubjectsVendorId}
                    setPersonsVendorId={setPersonsVendorId}
                    onOpenPrimaryContacts={onOpenPrimaryContacts}
                />
            ))}

            {vendorsList.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default VendorsTableBody;
